<template>
	<div class="page-content__content">
		<CategoryManagersTable />
	</div>
</template>

<script>

import CategoryManagersTable from "@/components/sections/CategoryManagers/CategoryManagersTable.vue";

export default {
	name: "CategoryManagersPage",
	components: {CategoryManagersTable},
}
</script>


